/// <reference types="@types/googlemaps" />
import { isPlatformBrowser } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
} from "@angular/forms";

// import { publicKey } from 'assets/certs/keys/keyconfig';
import { enc, SHA256 } from "crypto-js";
import * as timezone from "jstimezonedetect";
import { BehaviorSubject, Subject } from "rxjs";
import { apiRequest, ServiceBase } from "services";

import { environment } from "@env/environment";
import { BookingClass } from "@models/flight-search-params";
import { GetYTBCoupon, YTBCouponEmailItinery } from "@models/myCouponsInfo";
import { Userdata } from "@models/userdata";

import { ipstackapikey } from "../config/config";
import { authObj } from "../lookup-config";
import { JSEncrypt } from "jsencrypt";
import { ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
@Injectable({
  providedIn: "root",
})
export class CommonService extends ServiceBase {
  loca: string;
  ipAddress: any;
  geocoder: any;
  geolocationFromIp: any;
  BookingStatus: BehaviorSubject<any>;

  countrySuccess$: BehaviorSubject<any>;
  countrySignupSuccess$: BehaviorSubject<any>;
  SUBJECTTYPESUCCESS: BehaviorSubject<any>;
  EMAILSUCCESS: Subject<any>;
  GeoLocationFromServer: Subject<any>;
  GENERALEMAILSUCCESS: Subject<any>;
  ORGCOUNTRIES: BehaviorSubject<any>;
  ORGDETAILS: BehaviorSubject<any>;
  ORGDETAILSHOME: BehaviorSubject<any>;
  StateList: BehaviorSubject<any>;
  AllStateList: BehaviorSubject<any>;
  CurrencyList: BehaviorSubject<any>;
  CurrencyConverterValue: Subject<any>;
  BookingCurrencyConverterValue: Subject<any>;
  GetIpAddressUsingGeoPlugin: Subject<any>;
  GetAddressFromIPAddress: Subject<any>;
  GetIPAddressIPIFYSUCCESS: Subject<any>;

  EMERGENCYSUCCESS: BehaviorSubject<any>;
  RELATIONSUCCESS: BehaviorSubject<any>;
  DOCTYPESUCCESS: BehaviorSubject<any>;
  TRAVELTYPESUCCESS: BehaviorSubject<any>;
  ADDRESSTYPESUCCESS: BehaviorSubject<any>;
  GETBOOKINGINFO: Subject<any>;
  CONTACTSUCCESS: BehaviorSubject<any>;
  RestrictionCountrys: Subject<any>;
  PopularCurrencyList: Subject<any>;
  EMAILSUBSCRIPTION: BehaviorSubject<any>;
  BookingDetails: Subject<any>;
  geoLocationData: any = {};
  PhonetypeSucess: BehaviorSubject<any>;
  PAYMENTCARDTYPES: Subject<any>;
  SupplierManagerMappingDetails: BehaviorSubject<any>;
  EMAILITENARYSUCCESS: Subject<any>;
  mealPlanSuccess$: BehaviorSubject<any>;
  wheelChairTypesSuceess$: BehaviorSubject<any>;
  AirlineSuccess: BehaviorSubject<any>;
  FlightStaticData: BehaviorSubject<any>;
  CurrencyCountryIso2: Subject<any>;
  OrgContactSuccess$: BehaviorSubject<any>;
  GETUSERBOOKINGINFO: Subject<any>;
  SocialNetworkSuccess: Subject<any>;
  ADDRESSDETAILSFORUSERSUCESS: Subject<any>;
  EMERGENCYDETAILSFORUSERSUCESS: Subject<any>;
  SUPPLIERINFOSUCCESS: BehaviorSubject<any>;
  QUERYPARAMSINSERTSUCESS$: Subject<any>;
  QUERYPARAMSGETSUCESS$: Subject<any>;
  ADDITIONALQUERYPARAMSINSERTSUCESS$: Subject<any>;
  USERSIGNUPQUERYPARAMSGETSUCESS$: Subject<any>;
  AGENTSIGNUPQUERYPARAMSGETSUCESS$: Subject<any>;

  ADDITIONALDETAILSQUERYPARAMSINSERTSUCESS$: Subject<any>;

  FlightScheduleChange$: Subject<any>;
  currentMonth: any;
  currentday: any;
  GENDERSUCCESS$: BehaviorSubject<any>;
  BOOKINGCLASSSUCCESS: BehaviorSubject<any>;
  BAGGAGESUCCESS: Subject<any>;
  CARPICKUPLOCATIONADDRESS: Subject<any>;
  CARDROPOFFLOCATIONADDRESS: Subject<any>;
  errorSuccess: Subject<any>;
  destinationSuccess: Subject<any>;

  SITEMAINTAINANCEEXCEPTIONSUCCESS$: Subject<any>;
  EXCEPTIONSUCCESS$: Subject<any>;
  CommonAirlineSuccess: Subject<any>;
  paymentProcess: Subject<any>;
  MYCOUPONSCUCCESS: Subject<any>;
  COUPONEMAILSUCCESS: Subject<any>;
  GetModulesInfoSuccess: Subject<any>;

  VALIDATEUSEREMAILADDRESSSUCCESS: Subject<any>;

  RESENDEMAILCONFIRMATIONSSUCCESS: Subject<any>;
  TopDestinations: Subject<any>;
  couponValidate$: Subject<any>;
  ytbDynamicImages: Subject<any>;
  coupons: Subject<any>;
  deals$: Subject<any>;
  assignCoupons: Subject<any>;
  QUERYPARAMSHOTELINSERTSUCESS$: Subject<any>;
  keySuccess$: BehaviorSubject<{ data: string }>;
  fetchIPAdressSuccess$: Subject<{ ip: string }>;
  flightSegmentStatusSuccess$: BehaviorSubject<any>;
  token$: Subject<string>;

  GETQUERYPARAMSFROMCARLANDINGSUCCESS$: Subject<any>;

  GETQUERYPARAMSFROMACTIVITIESLANDINGSUCCESS$: Subject<any>;
  ACTIVITYCONFIRMATIONINSERTIONSUCCESS$: Subject<any>;
  HOTELCONFIRMATIONINSERTIONSUCCESS$: Subject<any>;
  FLIGHTCONFIRMATIONINSERTIONSUCCESS$: Subject<any>;
  BEFOREBOOKINGINSERTIONSUCCESS$: Subject<any>;

  FLIGHTQUERYPARAMSGETSUCESS$: Subject<any>;
  couponGetYTBCouponDetails$: Subject<any>;

  razorSuccess$: Subject<any>;
  PaymentCurrencyConverterValue: Subject<any>;
  enqHistory$: Subject<any>;
  PaypalDetails: Subject<any>;
  PostBookingDetailsInsertionSuccess$: Subject<any>;
  PostBookingSuccess$: Subject<any>;
  issueTicketSuccess$: Subject<any>;

  constructor(http: HttpClient, @Inject(PLATFORM_ID) private platformId) {
    super(http);

    this.PostBookingDetailsInsertionSuccess$ = new Subject<any>();
    this.PostBookingSuccess$ = new Subject<any>();

    this.PaypalDetails = new Subject<any>();
    this.couponGetYTBCouponDetails$ = new Subject<any>();

    this.FLIGHTQUERYPARAMSGETSUCESS$ = new Subject<any>();
    this.USERSIGNUPQUERYPARAMSGETSUCESS$ = new Subject<any>();
    this.AGENTSIGNUPQUERYPARAMSGETSUCESS$ = new Subject<any>();

    this.FLIGHTCONFIRMATIONINSERTIONSUCCESS$ = new Subject<any>();
    this.BEFOREBOOKINGINSERTIONSUCCESS$ = new Subject<any>();

    this.HOTELCONFIRMATIONINSERTIONSUCCESS$ = new Subject<any>();
    this.ACTIVITYCONFIRMATIONINSERTIONSUCCESS$ = new Subject<any>();

    this.GETQUERYPARAMSFROMCARLANDINGSUCCESS$ = new Subject<any>();
    this.GETQUERYPARAMSFROMACTIVITIESLANDINGSUCCESS$ = new Subject<any>();

    this.RESENDEMAILCONFIRMATIONSSUCCESS = new Subject<any>();

    this.VALIDATEUSEREMAILADDRESSSUCCESS = new Subject<any>();
    this.COUPONEMAILSUCCESS = new Subject<any>();
    this.MYCOUPONSCUCCESS = new Subject<any>();
    this.CommonAirlineSuccess = new Subject<any>();
    this.CARPICKUPLOCATIONADDRESS = new Subject<any>();
    this.CARDROPOFFLOCATIONADDRESS = new Subject<any>();
    this.SITEMAINTAINANCEEXCEPTIONSUCCESS$ = new Subject<any>();
    this.EXCEPTIONSUCCESS$ = new Subject<any>();

    this.GENDERSUCCESS$ = new BehaviorSubject<any>(undefined);
    this.countrySuccess$ = new BehaviorSubject<any>(undefined);
    this.countrySignupSuccess$ = new BehaviorSubject<any>(undefined);
    this.SUBJECTTYPESUCCESS = new BehaviorSubject<any>(undefined);
    this.ORGCOUNTRIES = new BehaviorSubject<any>(undefined);
    this.ORGDETAILS = new BehaviorSubject<any>(undefined);
    this.ORGDETAILSHOME = new BehaviorSubject<any>(undefined);
    this.EMAILSUCCESS = new Subject<any>();
    this.GENERALEMAILSUCCESS = new Subject<any>();
    this.StateList = new BehaviorSubject<any>(undefined);
    this.AllStateList = new BehaviorSubject<any>(undefined);
    this.CurrencyList = new BehaviorSubject<any>(undefined);
    this.CurrencyConverterValue = new Subject<any>();
    this.GeoLocationFromServer = new Subject<any>();
    this.PaymentCurrencyConverterValue = new Subject<any>();

    this.BookingCurrencyConverterValue = new Subject<any>();
    this.GetIpAddressUsingGeoPlugin = new Subject<any>();
    this.GetAddressFromIPAddress = new Subject<any>();
    this.GetIPAddressIPIFYSUCCESS = new Subject<any>();
    this.EMERGENCYSUCCESS = new BehaviorSubject<any>(undefined);
    this.RELATIONSUCCESS = new BehaviorSubject<any>(undefined);
    this.DOCTYPESUCCESS = new BehaviorSubject<any>(undefined);
    this.TRAVELTYPESUCCESS = new BehaviorSubject<any>(undefined);
    this.ADDRESSTYPESUCCESS = new BehaviorSubject<any>(undefined);
    this.GETBOOKINGINFO = new Subject<any>();
    this.CONTACTSUCCESS = new BehaviorSubject<any>(undefined);
    this.RestrictionCountrys = new Subject<any>();
    this.EMAILSUBSCRIPTION = new BehaviorSubject<any>(undefined);
    this.PopularCurrencyList = new Subject<any>();
    this.BookingDetails = new Subject<any>();
    this.PhonetypeSucess = new BehaviorSubject<any>(undefined);
    this.PAYMENTCARDTYPES = new Subject();
    this.SupplierManagerMappingDetails = new BehaviorSubject<any>(undefined);
    this.EMAILITENARYSUCCESS = new Subject<any>();
    this.mealPlanSuccess$ = new BehaviorSubject<any>(undefined);
    this.wheelChairTypesSuceess$ = new BehaviorSubject<any>(undefined);
    this.AirlineSuccess = new BehaviorSubject<any>(undefined);
    this.FlightStaticData = new BehaviorSubject<any>(undefined);
    this.CurrencyCountryIso2 = new Subject<any>();
    this.OrgContactSuccess$ = new BehaviorSubject<any>(undefined);
    this.GETUSERBOOKINGINFO = new Subject<any>();
    this.SocialNetworkSuccess = new Subject<any>();
    this.ADDRESSDETAILSFORUSERSUCESS = new Subject<any>();
    this.EMERGENCYDETAILSFORUSERSUCESS = new Subject<any>();
    this.SUPPLIERINFOSUCCESS = new BehaviorSubject<any>(undefined);

    this.QUERYPARAMSINSERTSUCESS$ = new Subject<any>();
    this.QUERYPARAMSGETSUCESS$ = new Subject<any>();
    this.ADDITIONALQUERYPARAMSINSERTSUCESS$ = new Subject<any>();
    this.ADDITIONALDETAILSQUERYPARAMSINSERTSUCESS$ = new Subject<any>();

    this.FlightScheduleChange$ = new Subject();
    this.BOOKINGCLASSSUCCESS = new BehaviorSubject<any>(undefined);
    this.BAGGAGESUCCESS = new Subject();
    this.errorSuccess = new Subject();
    this.destinationSuccess = new Subject();
    this.paymentProcess = new Subject();
    this.GetModulesInfoSuccess = new Subject<any>();
    this.TopDestinations = new Subject<any>();
    this.couponValidate$ = new Subject<any>();
    this.ytbDynamicImages = new Subject<any>();
    this.coupons = new Subject<any>();
    this.deals$ = new Subject<any>();
    this.assignCoupons = new Subject<any>();
    this.QUERYPARAMSHOTELINSERTSUCESS$ = new Subject<any>();
    this.keySuccess$ = new BehaviorSubject<{ data: string }>(undefined);
    this.fetchIPAdressSuccess$ = new Subject<{ ip: string }>();
    this.flightSegmentStatusSuccess$ = new BehaviorSubject<any>(undefined);
    this.token$ = new Subject<string>();
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      this.geocoder = new google.maps.Geocoder();
    }
    this.BookingStatus = new BehaviorSubject<any>(undefined);

    this.keySuccess$.next({ data: environment.publicKey });

    this.razorSuccess$ = new Subject();
    this.enqHistory$ = new Subject();
    this.issueTicketSuccess$ = new Subject();
  }

  encryptData(data: string, key: string): string | null {
    // Check if we are in the browser environment
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import JSEncrypt only in the browser
      // const JSEncrypt = require('jsencrypt').default;
      // const encryptor = new JSEncrypt();
      // encryptor.setPublicKey(key); // Replace with your actual public key
      // return encryptor.encrypt(data);
      // import('jsencrypt').then(({ JSEncrypt }) => {
      //   const encryptor = new JSEncrypt();
      //   encryptor.setPublicKey(key);
      //   return encryptor.encrypt(data);
      // }).catch(error => {
      //   console.error('Error loading JSEncrypt:', error);
      //   return null;
      // });
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(key);
      return encryptor.encrypt(data) || null;
    } else {
      // On server-side rendering (SSR), return null or handle accordingly
      console.log("Server-side rendering: Encryption is not available");
      return null;
    }
  }

  makePostBookingPaymentDetails(payment) {
    return this.post({
      url: "flightbook/flight/v1/FlightPostBookingPayment",
      data: payment,
      onNotify: this.PostBookingSuccess$,
    });
  }

  issueTicket(param) {
    return this.post({
      url: "flightbook//flight/v1/IssueTicket",
      data: param,
      onNotify: this.issueTicketSuccess$,
      operationKey: "issueTicket",

      handleErrorThroughSubject: true,
    });
  }

  getPostBookingPaymentDetails(payment) {
    return this.post({
      url: "Common/Booking/v1/RetrivePostBookingPayment",
      data: payment,
      onNotify: this.PostBookingDetailsInsertionSuccess$,
    });
  }

  makeRazorPayment(rzpayment) {
    return this.post({
      url: "Payments/RazorPay/Authorize",
      data: rzpayment,
      onNotify: this.razorSuccess$,
    });
  }

  // formatPaymentCards(cardTypeObject: any, cardListObjectArray: any[], cardNumber: any) {
  //   console.log(cardTypeObject);
  //   let gaps = cardTypeObject[0].gaps[0];
  //   console.log(gaps);
  //   let regExString = ".{1," + gaps + "}";
  //   console.log(regExString);

  //   let cardType: any = cardListObjectArray.filter(x => x.type == cardTypeObject[0].niceType);
  //   console.log(cardType);

  //   let creditCardNo = cardNumber.match(new RegExp(regExString, "g")).join("-");

  //   console.log(creditCardNo);

  //   return { 'cardNo': creditCardNo, 'cardLogo': cardType[0].images, 'cardCompany': cardTypeObject[0].niceType }
  // }

  /**
   *
   * @param requestObj query prams json object
   * this function is used to insert our query params object into database
   * It will takes request object value in string format
   */
  insertFlightSuccessQueryParamsInfo(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.FLIGHTCONFIRMATIONINSERTIONSUCCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  insertBeforeBookingQueryParamsInfo(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.BEFOREBOOKINGINSERTIONSUCCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  checkItIsDifferent(fDetails) {
    if (fDetails && fDetails.length) {
      for (let i = 0; i < fDetails.length; i++) {
        if (fDetails[i].isDifferentFromLocation) {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  /**
   *
   * @param requestObj query prams json object
   * this function is used to insert our query params object into database
   * It will takes request object value in string format
   */
  insertHotelSuccessQueryParamsInfo(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.HOTELCONFIRMATIONINSERTIONSUCCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  /**
   *
   * @param requestObj query prams json object
   * this function is used to insert our query params object into database
   * It will takes request object value in string format
   */
  insertActivitySuccessQueryParamsInfo(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.ACTIVITYCONFIRMATIONINSERTIONSUCCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  /**
   * This will take that form control name as input.
   * And it will check it for the mroe than one spaces are available or not in the string
   * If is available it will return space is true and otherwise if will return space as false
   * @returns  validation json input
   */

  spaceValidator(dateOfBirthVal: AbstractControl) {
    let nameValue = dateOfBirthVal.value;
    if (nameValue) {
      if (nameValue) {
        let indexValue = nameValue.indexOf("  ");
        if (indexValue >= 0) {
          return { space: true };
        } else {
          return null;
        }
      }
    }
    return null;
  }

  leftSidetrim(str) {
    let newString = "";
    if (str) {
      for (let j = 0; j < str.length; j++) {
        console.log(str[j], j);
        if (str[j] == " ") {
          str = str.substring(1, str.length);
          console.log(str);
        } else {
          return str.slice(j, str.length);
          break;
        }
      }
    } else {
      return str;
    }
  }

  rightSidetrim(str) {
    if (str) {
      for (let j = str.length - 1; j > -1; j--) {
        console.log(str[j]);
        if (str[j] == " ") {
          str = str.slice(0, j) + str.slice(j + 1);
          console.log(str);
        } else {
          return str;
          break;
        }
      }
    } else {
      return str;
    }
  }

  /**
   *
   * @param requestId request id which is coming while insert our query params into database
   * It will return all query params which we stored in database while navigation
   * It will return response in the form of string. So we need to do parse while we got response
   */
  getQueryParamsInfoFromCarLandingPage(requestId) {
    return this.post({
      url: "Common/Request/v1/GetQueryParams",
      data: { requestId: requestId },
      onNotify: this.GETQUERYPARAMSFROMCARLANDINGSUCCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  getQueryParamsInfoFromActivitiesLandingPage(requestId) {
    return this.post({
      url: "Common/Request/v1/GetQueryParams",
      data: { requestId: requestId },
      onNotify: this.GETQUERYPARAMSFROMACTIVITIESLANDINGSUCCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  getAllBookingStatus() {
    this.get<any>({
      url: "Common/Common/v1/GetAllBookingstatus",
      onNotify: this.BookingStatus,
      handleErrorThroughSubject: true,
      operationKey: "GetAllBookingStatus_issue",
    } as apiRequest<any>);
  }

  resendEmailConfirmation(emailInfo) {
    return this.post<any>({
      url: "Login/YTBB2CCustomer/v1/ResendEmailConfirmationForB2CCustomer",
      data: emailInfo,
      onNotify: this.RESENDEMAILCONFIRMATIONSSUCCESS,
    } as apiRequest<any>);
  }

  /**
   *
   * @param Email User ID
   * This function is used to validate user Email Address
   */

  validateB2CUserEmail(userId) {
    this.get({
      url:
        "Login/YTBB2CCustomer/v1/ValidateEmailOfB2CCustomerDetails/" + userId,
      onNotify: this.VALIDATEUSEREMAILADDRESSSUCCESS,
    });
  }

  getModules() {
    this.get<any>({
      url: "Common/Common/v1/modules",
      onNotify: this.GetModulesInfoSuccess,
    } as apiRequest<any>);
  }

  emailCouponToUser(emailCoupon: YTBCouponEmailItinery) {
    return this.post<any>({
      url: "Common/YTBCoupon/v1/YTBCouponEmailItinery",
      data: emailCoupon,
      onNotify: this.COUPONEMAILSUCCESS,
    } as apiRequest<any>);
  }

  getAllUserCoupons(couponInfo: GetYTBCoupon) {
    return this.post({
      url: "Common/YTBCoupon/v1/YTBUserCoupons",
      data: couponInfo,
      onNotify: this.MYCOUPONSCUCCESS,
    });
  }

  getCarPickupLocationAddress(code) {
    return this.post({
      url: "Common/EuroCarStationList",
      data: { StationCode: code },
      onNotify: this.CARPICKUPLOCATIONADDRESS,
    });
  }

  getCarDropoffLocationAddress(code) {
    return this.post({
      url: "Common/EuroCarStationList",
      data: { StationCode: code },
      onNotify: this.CARDROPOFFLOCATIONADDRESS,
    });
  }

  /**
   * This function will return browser time zone
   */
  getBrowserTimeZone() {
    return timezone.determine().name();
  }

  /**
   * @author Nagaraju
   * This function is used to get address from ipaddress and we will uses this response to store it in session      and cookies
   */
  getIp(url) {
    this.get({
      url: url,
      onNotify: this.GetIpAddressUsingGeoPlugin,
    });
  }

  /**
   *
   * @param ip ipaddress of user
   * This function is ued to get user address from ipaddress using ipstack
   */
  getDataUsingIpstackPlugin() {
    this.get({
      url: "https://api.ipify.org/?format=json",
      onNotify: this.GetIPAddressIPIFYSUCCESS,
      operationKey: "APIIPIFY_FAILURE",
    });
  }

  /**
   *
   * @param ip ipaddress of user
   * This function is ued to get user address from ipaddress using geoplugin
   */
  getDatausingGeoPlugin(url) {
    // this.get<any>({
    //   url: 'api/geolocation/',
    //   onNotify: this.GetAddressFromIPAddress,
    // } as apiRequest<any>);
    // this.get({
    //   url: url,
    //   onNotify: this.GetAddressFromIPAddress,
    //   operationKey: "IPSSLGET_FAILURE",
    // });
    return this.post({
      url: "Common/api/ipinfo",
      data: { url: url },
      onNotify: this.GetAddressFromIPAddress,
    });
  }

  /**
   *
   * @param position longitude and latitude
   * This function is used to get address from geoLocation and store it in session
   */
  getAddressFromLatLng(position, callback) {
    const lang = position.coords.longitude;
    const lati = position.coords.latitude;
    const latlng = { lat: lati, lng: lang };
    this.geocoder.geocode({ location: latlng }, (results, status) => {
      callback(results);
      // if (results) {
      //   for (var i = 0; i < results[0].address_components.length; i++) {
      //     var shortname = results[0].address_components[i].short_name;
      //     var longname = results[0].address_components[i].long_name;
      //     var type = results[0].address_components[i].types;
      //     if (type.indexOf("country") != -1) {
      //       if (!this.isNullOrWhitespace(shortname)) {
      //         this.geoLocationData.countryCode = shortname;
      //       } else {
      //         this.geoLocationData.countryName = longname;
      //       }
      //     }
      //   }
      //   this.geoLocationData.geoPluginCode = 2;
      //   this.geoLocationData.currencyCode = null;
      //   this.geoLocationData.langitude = lang;
      //   this.geoLocationData.latitude = lati;

      //   this.sharedService.setGeoLocationParams(this.geoLocationData);
      // } else {
      //   console.log("data is not coming properly");
      // }
    });
  }

  isNullOrWhitespace(text) {
    if (text == null) {
      return true;
    }
    return text.replace(/\s/gi, "").length < 1;
  }

  /**
   * This function is used to get All countrys
   */
  getCountries() {
    this.get<any>({
      url: "Common/Country/v1/Countries",
      onNotify: this.countrySuccess$,
    } as apiRequest<any>);
  }

  /**
   * This function is used to get All countrys
   */
  getSignupCountries() {
    this.get<any>({
      url: "Common/Country/v1/Countries",
      onNotify: this.countrySignupSuccess$,
    } as apiRequest<any>);
  }

  getSubjectTypes() {
    this.get<any>({
      url: "Common/EnquirySubject",
      onNotify: this.SUBJECTTYPESUCCESS,
    } as apiRequest<any>);
  }

  postEmail(data) {
    delete data["phonecode"];
    // data['Type'] = B2C_LOOKUP.ENQUIRY.GEN;
    this.post({
      url: "Common/GeneralEnquiry/v1/FeedBack",
      data: data,
      onNotify: this.EMAILSUCCESS,
    } as apiRequest<boolean>);
  }

  postemailSubscription(data) {
    this.post({
      url: "Common/EmailSubscription/v1/EmailSubscription",
      data: data,
      onNotify: this.EMAILSUBSCRIPTION,
    } as apiRequest<boolean>);
  }

  getOrganizationCountries() {
    this.get<any>({
      url: "Common/ContactUs/v1/GetContactUsCountry",
      onNotify: this.ORGCOUNTRIES,
    } as apiRequest<any>);
  }

  postContactUsDetails(data) {
    this.post<any>({
      url: "Common/ContactUs/v1/GetContactUsByIso2",
      data: data,
      onNotify: this.ORGDETAILS,
    } as apiRequest<any>);
  }

  getContactUsDetails(data) {
    this.post<any>({
      url: "Common/ContactUs/v1/GetContactUsByIso2",
      data: data,
      onNotify: this.ORGDETAILSHOME,
    } as apiRequest<any>);
  }

  getPhoneTypes() {
    this.get<any>({
      url: "Common/PhoneTypes/v1/GetPhoneTypes",
      onNotify: this.PhonetypeSucess,
    } as apiRequest<any>);
  }

  /**
   *
   * @param countrycode
   * This function is used to get states for particular Country based on countryiso2
   */
  getState(countrycode) {
    return this.post({
      url: "Common/State/v1/StateByISO2",
      data: { country_ISO2: countrycode },
      onNotify: this.StateList,
    } as apiRequest<boolean>);
  }

  /**
   *
   * @param countrycode
   * This function is used to get states for particular Country based on countryiso2
   */
  getAllState() {
    return this.get({
      url: "Common/State",
      onNotify: this.AllStateList,
    } as apiRequest<boolean>);
  }

  makePaypalPayment(paymentDetails) {
    this.post<any>({
      url: "Payments/PayPal/MakePayment",
      onNotify: this.PaypalDetails,
      data: paymentDetails,
    } as apiRequest<any>);
  }

  /**
   * This function is used to get all the Currency's
   */
  getAllCurrency() {
    return this.get({
      url: "Common/Common/v1/Popularcurrency",
      onNotify: this.CurrencyList,
    } as apiRequest<boolean>);
  }

  /**
   * This funcion is used to fetch popular Currencies and Normal currencies as Different Arrays.
   */
  getPopularCurrencies() {
    try {
      this.get({
        url: "Common/Common/v1/Popularcurrency",
        onNotify: this.PopularCurrencyList,
      } as apiRequest<boolean>);
      console.log("%%%%%%%%%%%%%%% 1");
    } catch (e) {
      console.log("%%%%%%%%%%%%%%% 2", e);
    }
  }

  /**
   *
   * @param fromcurrency
   * @param tocurrency
   * This function is used to return equal amount to fromcurrency and tocurrency
   */

  currencyConverter(fromcurrency, tocurrency) {
    return this.post({
      url: "Common/CurrencyConverter/v1/currencyConverter",
      data: { fromcurrency: fromcurrency, tocurrency: tocurrency },
      onNotify: this.CurrencyConverterValue,
    } as apiRequest<boolean>);
  }

  /**
   *
   * @param fromcurrency
   * @param tocurrency
   * This function is used to return equal amount to fromcurrency and tocurrency
   */

  paymentCurrencyConverter(fromcurrency, tocurrency) {
    return this.post({
      url: "Common/CurrencyConverter/v1/currencyConverter",
      data: { fromcurrency: fromcurrency, tocurrency: tocurrency },
      onNotify: this.PaymentCurrencyConverterValue,
    } as apiRequest<boolean>);
  }

  /**
   * This function is used to convert amount into USD format at the timem of booking
   * @param fromcurrency
   * @param tocurrency
   */
  bookingCurrencyConverter(fromcurrency, tocurrency) {
    return this.post({
      url: "Common/CurrencyConverter/v1/currencyConverter",
      data: { fromcurrency: fromcurrency, tocurrency: tocurrency },
      onNotify: this.BookingCurrencyConverterValue,
    } as apiRequest<boolean>);
  }

  /**
   *
   * @param coutrydata
   * This function is used to check wheather search station is restricted for booking or not.
   */

  getBookingRestrictedCountrys() {
    return this.get({
      url: "Common/BookingRestrictedCountrys/v1/BookingRestrictedCountrys",
      onNotify: this.RestrictionCountrys,
    });
  }

  /**
   *
   * @param date
   * this will convert data into our required format which we need to store it in the database
   */
  getDateAdd(date, remove, returnType = "string") {
    let regExp = new RegExp("-", "g");
    let d = date as Date;
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let c = new Date(year, month, day + 1);
    let strDate = c.toISOString().substring(0, 10);
    if (returnType == "object") {
      return c;
    } else {
      if (remove != "") {
        return strDate.replace(regExp, "");
      } else {
        return strDate;
      }
    }
  }

  setDateOfBirthDate(dateofBirth) {
    let newFormDate = "";
    if (dateofBirth) {
      let dbDate = new Date(dateofBirth);
      if (dbDate.getMonth() + 1 > 9) {
        newFormDate += dbDate.getMonth() + 1 + "/";
      } else {
        newFormDate += "0" + (dbDate.getMonth() + 1) + "/";
      }

      if (dbDate.getDate() > 9) {
        newFormDate += dbDate.getDate() + "/";
      } else {
        newFormDate += "0" + dbDate.getDate() + "/";
      }
      newFormDate += dbDate.getFullYear();

      return newFormDate;
    }
    return dateofBirth;
  }

  dateOfBirthDate(
    event,
    psgr: UntypedFormGroup,
    formGroupIndex,
    formArrayIndex
  ) {
    let value = psgr.controls["dob"].value;
    if (value != null && value != undefined && value != "") {
      if (value.length == 2 && value <= 31) {
        value += "/";
      } else if (value.length == 2 && value > 31) {
        value = "";
      }

      if (value.length == 5 && value.substring(3, 5) <= 12) {
        value += "/";
      } else if (value.length == 5 && value.substring(3, 5) > 12) {
        value = value.substring(0, 3);
      }
      // let inputvalue = value.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
      psgr.controls["dob"].setValue(value);
    }
  }

  dateOfPassportExpityDate(
    event,
    psgr: UntypedFormGroup,
    formGroupIndex,
    formArrayIndex
  ) {
    let value = psgr.controls["passportexpirydate"].value;
    if (value != null && value != undefined && value != "") {
      if (value.length == 2 && value <= 31) {
        value += "/";
      } else if (value.length == 2 && value > 31) {
        value = "";
      }

      if (value.length == 5 && value.substring(3, 5) <= 12) {
        value += "/";
      } else if (value.length == 5 && value.substring(3, 5) > 12) {
        value = value.substring(0, 3);
      }
      // let inputvalue = value.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
      psgr.controls["passportexpirydate"].setValue(value);
    }
  }

  validatePassportExpiryDateDynamic(
    dateOfBirthVal: AbstractControl,
    arrivalDate
  ): ValidatorFn {
    let newDate = new Date(arrivalDate);
    let presentDate = newDate.getDate();
    let presentMonth = newDate.getMonth();
    let presentYear = newDate.getFullYear();
    if (dateOfBirthVal == null)
      // return false;
      dateOfBirthVal.setErrors(null);
    let validatePattern = /[0-9]{2}[/][0-9]{2}[/][0-9]{4}$/;
    // let dateValues = dateOfBirthVal.match(validatePattern);
    // if (dateValues == null) {
    // alert("Date of birth should be null and it should in the format of yyyy-mm-dd")
    // return false;
    // }
    console.log(dateOfBirthVal.value);

    if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length < 10
    ) {
      // return {
      //   dobInvalid: true
      // };
      return;
    } else if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length == 10
    ) {
      let birthYear = dateOfBirthVal.value.substring(6, 10);
      let birthMonth = dateOfBirthVal.value.substring(0, 2);
      let birthDate = dateOfBirthVal.value.substring(3, 5);
      console.log(birthDate + " " + birthMonth + " " + birthYear);
      if (birthMonth < 1 || birthMonth > 12) {
        // alert("Invalid date")
        dateOfBirthVal.setErrors({
          dobInvalid: true,
        });
      } else if (birthDate < 1 || birthDate > 31) {
        // alert("Invalid date")
        dateOfBirthVal.setErrors({
          dobInvalid: true,
        });
      } else if (
        (birthMonth == 4 ||
          birthMonth == 6 ||
          birthMonth == 9 ||
          birthMonth == 11) &&
        birthDate == 31
      ) {
        // alert("Invalid date for 31 days")
        dateOfBirthVal.setErrors({
          dobInvalid: true,
        });
      } else if (birthMonth == 2) {
        let isleap =
          birthYear % 4 == 0 && (birthYear % 100 != 0 || birthYear % 400 == 0);
        if (birthDate > 29 || (birthDate == 29 && !isleap)) {
          // alert("Invalid date")
          dateOfBirthVal.setErrors({
            dobInvalid: true,
          });
        }
      } else if (birthYear < presentYear) {
        // alert("Invalid Year")
        dateOfBirthVal.setErrors({
          dobInvalid: true,
        });
      } else if (birthYear == presentYear) {
        if (birthMonth < presentMonth + 1) {
          // alert("Invalid Month")
          dateOfBirthVal.setErrors({
            dobInvalid: true,
          });
        } else if (birthMonth == presentMonth + 1) {
          if (birthDate < presentDate) {
            // alert("Invalid date for same month ")
            dateOfBirthVal.setErrors({
              dobInvalid: true,
            });
          }
        }
      }
      dateOfBirthVal.setErrors(null);
    }
  }

  validatePassportExpiryDate(dateOfBirthVal: AbstractControl) {
    let newDate = new Date();
    let presentDate = newDate.getDate();
    let presentMonth = newDate.getMonth();
    let presentYear = newDate.getFullYear();
    if (dateOfBirthVal == null) return false;
    var validatePattern = /[0-9]{2}[/][0-9]{2}[/][0-9]{4}$/;
    // let dateValues = dateOfBirthVal.match(validatePattern);
    // if (dateValues == null) {
    // alert("Date of birth should be null and it should in the format of yyyy-mm-dd")
    // return false;
    // }

    if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length < 10
    ) {
      // return {
      //   dobInvalid: true
      // };
      return;
    } else if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length == 10
    ) {
      let birthYear = dateOfBirthVal.value.substring(6, 10);
      let birthMonth = dateOfBirthVal.value.substring(0, 2);
      let birthDate = dateOfBirthVal.value.substring(3, 5);
      console.log(birthDate + " " + birthMonth + " " + birthYear);
      if (birthMonth < 1 || birthMonth > 12) {
        // alert("Invalid date")
        return {
          dobInvalid: true,
        };
      } else if (birthDate < 1 || birthDate > 31) {
        // alert("Invalid date")
        return {
          dobInvalid: true,
        };
      } else if (
        (birthMonth == 4 ||
          birthMonth == 6 ||
          birthMonth == 9 ||
          birthMonth == 11) &&
        birthDate == 31
      ) {
        // alert("Invalid date for 31 days")
        return {
          dobInvalid: true,
        };
      } else if (birthMonth == 2) {
        var isleap =
          birthYear % 4 == 0 && (birthYear % 100 != 0 || birthYear % 400 == 0);
        if (birthDate > 29 || (birthDate == 29 && !isleap)) {
          // alert("Invalid date")
          return {
            dobInvalid: true,
          };
        }
      } else if (birthYear < presentYear) {
        // alert("Invalid Year")
        return {
          dobInvalid: true,
        };
      } else if (birthYear == presentYear) {
        if (birthMonth < presentMonth + 1) {
          // alert("Invalid Month")
          return {
            dobInvalid: true,
          };
        } else if (birthMonth == presentMonth + 1) {
          if (birthDate < presentDate) {
            // alert("Invalid date for same month ")
            return {
              dobInvalid: true,
            };
          }
        }
      }
      return false;
    }
  }

  validateDate(dateOfBirthVal: AbstractControl) {
    let newDate = new Date();
    let presentDate = newDate.getDate();
    let presentMonth = newDate.getMonth();
    let presentYear = newDate.getFullYear();
    if (dateOfBirthVal == null) return null;
    var validatePattern = /[0-9]{2}[/][0-9]{2}[/][0-9]{4}$/;
    // let dateValues = dateOfBirthVal.match(validatePattern);
    // if (dateValues == null) {
    // alert("Date of birth should be null and it should in the format of yyyy-mm-dd")
    // return false;
    // }

    if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length < 10
    ) {
      return {
        dobNotFilled: true
      };
      return;
    } else if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length == 10
    ) {
      let birthYear = dateOfBirthVal.value.substring(6, 10);
      let birthMonth = dateOfBirthVal.value.substring(0, 2);
      let birthDate = dateOfBirthVal.value.substring(3, 5);
      console.log(birthDate + " " + birthMonth + " " + birthYear);
      if (birthMonth < 1 || birthMonth > 12) {
        // alert("Invalid date")
        return {
          dobInvalid: true,
        };
      } else if (birthDate < 1 || birthDate > 31) {
        // alert("Invalid date")
        return {
          dobInvalid: true,
        };
      } else if (
        (birthMonth == 4 ||
          birthMonth == 6 ||
          birthMonth == 9 ||
          birthMonth == 11) &&
        birthDate == 31
      ) {
        // alert("Invalid date for 31 days")
        return {
          dobInvalid: true,
        };
      } else if (birthMonth == 2) {
        var isleap =
          birthYear % 4 == 0 && (birthYear % 100 != 0 || birthYear % 400 == 0);
        if (birthDate > 29 || (birthDate == 29 && !isleap)) {
          // alert("Invalid date")
          return {
            dobInvalid: true,
          };
        }
      }

      // 2010 + 70
      else if (
        birthYear > presentYear ||
        parseInt(birthYear) + 100 < presentYear
      ) {
        // alert("Invalid Year")
        return {
          dobInvalid: true,
        };
      } else if (birthYear == presentYear) {
        if (birthMonth > presentMonth + 1) {
          // alert("Invalid Month")
          return {
            dobInvalid: true,
          };
        } else if (birthMonth == presentMonth + 1) {
          if (birthDate > presentDate) {
            // alert("Invalid date for same month ")
            return {
              dobInvalid: true,
            };
          }
        }
      }
      return null;
    }
  }

  

  validateDateChildCase(dateOfBirthVal: AbstractControl) {
    let newDate = new Date();
    let presentDate = newDate.getDate();
    let presentMonth = newDate.getMonth();
    let presentYear = newDate.getFullYear();
    if (dateOfBirthVal == null) return false;
    var validatePattern = /[0-9]{2}[/][0-9]{2}[/][0-9]{4}$/;
    // let dateValues = dateOfBirthVal.match(validatePattern);
    // if (dateValues == null) {
    // alert("Date of birth should be null and it should in the format of yyyy-mm-dd")
    // return false;
    // }

    if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length < 10
    ) {
      // return {
      //   dobInvalid: true
      // };
      return;
    } else if (
      dateOfBirthVal &&
      dateOfBirthVal.value &&
      dateOfBirthVal.value.length == 10
    ) {
      let birthYear = dateOfBirthVal.value.substring(6, 10);
      let birthMonth = dateOfBirthVal.value.substring(0, 2);
      let birthDate = dateOfBirthVal.value.substring(3, 5);
      console.log(birthDate + " " + birthMonth + " " + birthYear);
      if (birthMonth < 1 || birthMonth > 12) {
        // alert("Invalid date")
        return {
          dobInvalid: true,
        };
      } else if (birthDate < 1 || birthDate > 31) {
        // alert("Invalid date")
        return {
          dobInvalid: true,
        };
      } else if (
        (birthMonth == 4 ||
          birthMonth == 6 ||
          birthMonth == 9 ||
          birthMonth == 11) &&
        birthDate == 31
      ) {
        // alert("Invalid date for 31 days")
        return {
          dobInvalid: true,
        };
      } else if (birthMonth == 2) {
        var isleap =
          birthYear % 4 == 0 && (birthYear % 100 != 0 || birthYear % 400 == 0);
        if (birthDate > 29 || (birthDate == 29 && !isleap)) {
          // alert("Invalid date")
          return {
            dobInvalid: true,
          };
        }
      }

      // 2010 + 70
      else if (
        birthYear > presentYear ||
        parseInt(birthYear) + 100 < presentYear
      ) {
        // alert("Invalid Year")
        return {
          dobInvalid: true,
        };
      } else if (birthYear == presentYear) {
        if (birthMonth > presentMonth + 1) {
          // alert("Invalid Month")
          return {
            dobInvalid: true,
          };
        } else if (birthMonth == presentMonth + 1) {
          if (birthDate > presentDate) {
            // alert("Invalid date for same month ")
            return {
              dobInvalid: true,
            };
          }
        }
      }
      return false;
    }
  }

  validaPhoneNumber(phoneNumber: AbstractControl) {
    if (!phoneNumber) return;
    else {
      let val = phoneNumber.value;

      // const hasError = validate({ val: val }, { val: { numericality: { noStrings: true } } });
      // if (hasError) return null;
      return val;
    }
  }

  validateDateFunction(dateOfBirthVal) {
    let newDate1 = new Date();
    let presentDate = newDate1.getDate();
    let presentMonth = newDate1.getMonth();
    let presentYear = newDate1.getFullYear();

    let newDate = new Date(presentYear + 15, presentMonth, presentDate);

    if (dateOfBirthVal == null) return false;
    var validatePattern = /[0-9]{2}[/][0-9]{2}[/][0-9]{4}$/;
    let dateValues = dateOfBirthVal.match(validatePattern);
    if (dateValues == null) {
      // alert("Date of birth should be null and it should in the format of yyyy-mm-dd")
      return false;
    }
    console.log(dateValues);
    var birthYear = dateOfBirthVal.substring(6, 10);
    var birthMonth = dateOfBirthVal.substring(0, 2);
    var birthDate = dateOfBirthVal.substring(3, 5);
    // alert(birthDate+" "+birthMonth+" "+birthYear);
    if (birthMonth < 1 || birthMonth > 12) {
      // alert("Invalid date")
      return false;
    } else if (birthDate < 1 || birthDate > 31) {
      // alert("Invalid date")
      return false;
    } else if (
      (birthMonth == 4 ||
        birthMonth == 6 ||
        birthMonth == 9 ||
        birthMonth == 11) &&
      birthDate == 31
    ) {
      // alert("Invalid date")
      return false;
    } else if (birthMonth == 2) {
      var isleap =
        birthYear % 4 == 0 && (birthYear % 100 != 0 || birthYear % 400 == 0);
      if (birthDate > 29 || (birthDate == 29 && !isleap)) {
        // alert("Invalid date")
        return false;
      }
    } else if (birthYear > presentYear || birthYear + 15 >= presentYear) {
      // alert("Invalid date")
      return false;
    } else if (birthYear == presentYear) {
      if (birthMonth > presentMonth + 1) {
        // alert("Invalid date")
        return false;
      } else if (birthMonth == presentMonth + 1) {
        if (birthDate > presentDate) {
          // alert("Invalid date")
          return false;
        }
      }
    }
    return true;
  }

  getDateAddFromString(dateOfBirth, differenceCharacter = "/") {
    if (
      dateOfBirth.length === 10 &&
      dateOfBirth.toString().charAt(2) == "/" &&
      dateOfBirth.toString().charAt(5) == "/"
    )
      return (
        dateOfBirth.substring(dateOfBirth.length - 4) +
        differenceCharacter +
        dateOfBirth.substring(0, 2).toString() +
        differenceCharacter +
        dateOfBirth.substring(3, 5)
      );
    else return dateOfBirth;
  }

  numberAddDate(date, count) {
    let regExp = new RegExp("-", "g");
    let d = date as Date;
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let c = new Date(year, month, day + 1);
    let strDate = c.toISOString().substring(0, 10);

    return strDate;
  }

  /**
   *
   * @param date Actual data
   * This function is used to add one date extra to the currenct date
   */
  setDate(date, remove) {
    if (date == null || date == "" || date == undefined) {
      return null;
    } else {
      return this.getDateAdd(date, remove);
    }
  }

  /**
   *
   * @param time Actual time
   * This funciton is used to convert time format to   "HHMM" format
   */
  setTimeOnly(time) {
    if (time === null || time === "" || time === undefined) {
      return null;
    } else {
      let regExp = new RegExp(":", "g");
      return time.replace(regExp, "");
    }
  }
  /*
   @description : This common method is used to prepare data for ytb-drodown
   Here it will bind one default value to display it as first element in dropdown
  */
  prepareDropdownResponse(res, label, value, addonLabel = "") {
    var responseArray = [
      { label: "Select" + (addonLabel ? " " + addonLabel : ""), value: "" },
    ];
    for (let response of res) {
      responseArray.push({ label: response[label], value: response[value] });
    }
    return responseArray;
  }

  /*
  @description : This common method is used to prepare data for ytb-drodown
  Here it will bind one default value to display it as first element in dropdown
 */
  prepareDropdownResponse1(res, label, value, origional, addonLabel = "") {
    var responseArray = [
      {
        label: "Select" + (addonLabel ? " " + addonLabel : ""),
        value: "",
        origionalvalue: "",
      },
    ];
    for (let response of res) {
      responseArray.push({
        label: response[label],
        value: response[value],
        origionalvalue: response[origional],
      });
    }
    return responseArray;
  }

  /**
   *
   * @param res         Total Array
   * @param label       Label to display
   * @param value       Value to come after select
   * @param origional   Image what you are displaying
   * @param iso2        Country ISO2
   */
  preparePhoneCodesDropdownResponse(
    res,
    label,
    value,
    origional,
    iso2,
    iso3,
    addonLabel: string = ""
  ) {
    var responseArray = [
      {
        label: "Select" + (addonLabel ? " " + addonLabel : ""),
        value: "",
        origionalvalue: "",
        iso2: "",
        iso3: "",
      },
    ];

    for (let response of res) {
      responseArray.push({
        label: response[label],
        value: response[value],
        origionalvalue: response[origional],
        iso2: response[iso2],
        iso3: response[iso3],
      });
    }
    return responseArray;
  }

  /*
   @description : This common method is used to prepare data for ytb-multiselect 
   Here it will not append default label for multiselect
  */
  prepareMultiselectDropdownResponse(res, label, value) {
    var responseArray = [];
    for (let response of res) {
      responseArray.push({ label: response[label], value: response[value] });
    }
    return responseArray;
  }

  prepareCurrencyDropdownResponse(res, label, value) {
    var responseArray = [];
    for (let response of res) {
      responseArray.push({
        label: response[label] + " - " + response[value],
        value: response[value],
      });
    }
    return responseArray;
  }

  /**
   *
   * @param formGroup Name of the formgroup which we need to do validations
   * This funciton is used to set validations to formgroup
   */
  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   *
   * @param lang value which we need to store it in session
   * @param key  Key name which we need to store data in session based on the name
   */
  setSession(lang, key) {
    sessionStorage.setItem(key, lang);
  }

  /**
   *
   * @param fromamount actual currency amount
   * @param value  Actual amount
   * @param toamount To convert currency amount
   * This function is used to add currency amount based on from and to curency amounts
   */
  addCurrencyValue(fromamount, value, toamount) {
    if (value && fromamount && toamount) {
      let currentvalue = parseFloat(value) / parseFloat(fromamount);
      return currentvalue * toamount;
    } else {
      return value;
    }
  }

  /*
 @description : common method for setting form values while edit
*/
  setFormValue(response, form) {
    Object.keys(form.value).forEach((value) => {
      Object.keys(response).forEach((responseObj) => {
        if (responseObj == value) {
          if (form.controls[responseObj].length > 0) {
            // if the form control name is an array dont set anything
          } else {
            form.controls[responseObj].setValue(response[responseObj]);
          }
        }
      });
    });
  }

  /**
   *
   * @param fromcurrency
   * @param tocurrency
   * This function is used to convert currency into current
   */
  updateCurrencyValues(fromcurrency, tocurrency) {
    if (fromcurrency != tocurrency) {
      this.currencyConverter(fromcurrency, tocurrency);
    }
  }

  /**
   *
   * @param date
   * This function is used to get Expiry date for Credeit
   */
  monthDate(date) {
    let regExp = new RegExp("-", "g");
    let d = date;
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let c = new Date(year, month, day + 1);
    let strDate = c.toISOString().substring(0, 7);
    return strDate;
  }

  DateDiff(fromdate, todate) {
    let dt1 = new Date(fromdate);
    let dt2 = new Date(todate);
    return Math.abs(
      Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      )
    );
  }

  getDay(date) {
    let days = [
      { label: "Sun", value: 0 },
      { label: "Mon", value: 1 },
      { label: "Tue", value: 2 },
      { label: "Wed", value: 3 },
      { label: "Thu", value: 4 },
      { label: "Fri", value: 5 },
      { label: "Sat", value: 6 },
    ];
    let dt = new Date(date);
    let day = days.filter((d) => d.value == dt.getDay());
    return day[0].label;
  }
  getKeyFromListByValue(list, value) {
    var label = "";
    for (let option of list) {
      if (option.value === value) {
        label = option.label;
        break;
      }
    }

    if (!label) {
      label = value;
    }
    return label;
  }

  getKeyFromListWithKeyName(list, value, label, keyname) {
    var lable = "";
    for (let option of list) {
      if (option[label] == value) {
        lable = option[keyname];
        break;
      }
    }
    return lable;
  }

  emergencydtls(data) {
    this.post<any>({
      url: "EmergencyContact/v1/EmergencyContact",
      data: data,
      onNotify: this.EMERGENCYSUCCESS,
    } as apiRequest<any>);
  }

  getRelations() {
    this.get<any>({
      url: "Common/Relationship/v1/GetAllRelationships",
      onNotify: this.RELATIONSUCCESS,
    } as apiRequest<any>);
  }

  getGendersList() {
    this.get<any>({
      url: "Common/Common/v1/GetAllGenders",
      onNotify: this.GENDERSUCCESS$,
    } as apiRequest<any>);
  }

  getDocumentTypes() {
    this.get<any>({
      url: "Common/TravelDocumentGet/v1/GetAllTravelDocuments",
      onNotify: this.DOCTYPESUCCESS,
    } as apiRequest<any>);
  }

  getTravelTypes() {
    this.get<any>({
      url: "Common/FrequentTravellerType/v1/GetAllFrequentTravellerType",
      onNotify: this.TRAVELTYPESUCCESS,
    } as apiRequest<any>);
  }
  getAddressTypes() {
    this.get<any>({
      url: "Common/AddressType/v1/GetAllAddressTypes",
      onNotify: this.ADDRESSTYPESUCCESS,
    } as apiRequest<any>);
  }
  /**
   *
   * @param get Booking count
   * This function is used to get no.of booking count of customer
   */
  getBookingInfo(userid) {
    this.post<any>({
      url: "Backoffice/BookingInformation/v1/GetByUserId",
      data: userid,
      onNotify: this.GETBOOKINGINFO,
    } as apiRequest<any>);
  }

  getContactTypes() {
    this.get<any>({
      url: "Common/ContactType",
      onNotify: this.CONTACTSUCCESS,
    } as apiRequest<any>);
  }

  validateAllFormArrayFields(formArray: UntypedFormArray) {
    Object.keys(formArray.controls).forEach((form) => {
      const control = formArray.get(form);
      if (control instanceof UntypedFormGroup) {
        this.validateNestedFormArrayFields(control);
      }
    });
  }

  validateNestedFormArrayFields(form: UntypedFormGroup) {
    Object.keys(form.controls).forEach((formName) => {
      const control = form.get(formName);
      if (control instanceof UntypedFormArray) {
        this.validateAllFormArrayFields(control);
      } else if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  /**
   *
   *  @description: MustMatch function is used to check that two fields match
   * @param :controlName,matchcontrollName
   */

  MustMatch(controlName: string, matchcontriolName: string) {
    return (formgroup: UntypedFormGroup) => {
      const control = formgroup.controls[controlName];
      const matchingname = formgroup.controls[matchcontriolName];
      if (matchingname.errors && !matchingname.errors.mustmatch) {
        return;
      }

      if (control.value != matchingname.value) {
        matchingname.setErrors({ mustmatch: true });
      } else {
        matchingname.setErrors(null);
      }
    };
  }

  GetBookingDetails(bookingObj) {
    this.post<any>({
      url: "Common/Booking/v1/GetBookingDetails",
      data: bookingObj,
      onNotify: this.BookingDetails,
    } as apiRequest<any>);
  }

  dateDiff(fromDate, toDate) {
    let date1 = new Date(fromDate);
    let date2 = new Date(toDate);
    let differenceInTime = date2.getTime() - date1.getTime();
    let differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
  }
  getPaymentCardTypes() {
    return this.get<any>({
      url: "Common/PaymentCardTypes/v1/GetAllPaymentCardTypesDetails",
      onNotify: this.PAYMENTCARDTYPES,
    });
  }

  getSupplierManagerMappingDetails() {
    return this.get<any>({
      url: "Common/SupplierManagerMapping/v1/GetAllSupplierMangerMappings",
      onNotify: this.SupplierManagerMappingDetails,
    });
  }

  emailitenary(data) {
    this.post({
      url: "Common/Booking/v1/Emailitinerary",
      data: data,
      onNotify: this.EMAILITENARYSUCCESS,
    } as apiRequest<boolean>);
  }

  mealPlans(suppliercode: string) {
    this.post<any>({
      url: "Common/MealPlanDetails/v1/GetMealPlanDetailsBySupplierCode",
      data: { supplierCode: suppliercode },
      onNotify: this.mealPlanSuccess$,
    } as apiRequest<any>);
  }

  wheelChairTypes(suppliercode: string) {
    this.post<any>({
      url: "Common/SpecialServices/v1/SpecialServicesBySupplierCode",
      data: { supplierCode: suppliercode },
      onNotify: this.wheelChairTypesSuceess$,
    } as apiRequest<any>);
  }

  prepareCountryResponse(res, label, value, origional, iso2, iso3) {
    var responseArray = [
      {
        label: "Select Phone Country Code",
        value: "",
        origionalvalue: "",
        phonecode: "",
        iso2: "",
        iso3: "",
      },
    ];
    for (let response of res) {
      responseArray.push({
        label: response[label],
        value: response[iso2],
        origionalvalue: response[origional],
        phonecode: response[value],
        iso2: response[iso2],
        iso3: response[iso3],
      });
    }
    return responseArray;
  }
  getAirlineNamesByStaticData() {
    this.get<any>({
      url: "Common/FlightStaticData/v1/GetAirlineNamesByStaticData",
      onNotify: this.AirlineSuccess,
    } as apiRequest<any>);
  }

  getCommonAirlineNamesByStaticData() {
    this.get<any>({
      url: "Common/FlightStaticData/v1/GetAirlineNamesForFlightService",
      onNotify: this.CommonAirlineSuccess,
    } as apiRequest<any>);
  }

  flightstaticdtata(airlinecode) {
    this.post<any>({
      url: "Common/FlightStaticData/v1/GetByAirlineCode",
      data: airlinecode,
      onNotify: this.FlightStaticData,
    } as apiRequest<any>);
  }

  /**
   *
   * @param countryCode geo location country code
   * This function is used to get the currency for that particular country by iso2.
   */

  getCurrencybyCountryIso2(countryCode) {
    // let countryObj;
    // countryObj.countryiso2 = countryCode;
    this.post({
      url: "Common/Common/v1/currencybyCountryIso2",
      data: { countryiso2: countryCode },
      onNotify: this.CurrencyCountryIso2,
    });
  }

  validateCurrentExpiryMonthAndYear(year, month) {
    let date = new Date();
    console.log(date.getFullYear());
    console.log(date.getMonth());

    console.log(year, month);

    if (year === date.getFullYear().toString()) {
      if (month < date.getMonth()) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  getLowerCaseString(name: string = "YB.png") {
    return name ? name.toLocaleLowerCase() : "yb.png";
  }

  getContactUsDetailsByISO2(iso2: string) {
    let data = { countryISO2: iso2 };
    this.post<any>({
      url: "Common/ContactUs/v1/GetContactUsByIso2",
      data: data,
      onNotify: this.OrgContactSuccess$,
    } as apiRequest<any>);
  }

  dateformat(date: Date) {
    this.currentMonth = date.getMonth() + 1;
    this.currentday = date.getDate();
    if (this.currentMonth < 10) {
      this.currentMonth = "0" + this.currentMonth;
    } else {
      this.currentMonth = "" + this.currentMonth;
    }
    if (this.currentday < 10) {
      this.currentday = "0" + this.currentday;
    } else {
      this.currentday = "" + this.currentday;
    }
    var newdate =
      this.currentMonth + "/" + this.currentday + "/" + date.getFullYear();
    return newdate;
  }

  getUserBooking(userdata: Userdata) {
    this.post<any>({
      url: "Backoffice/BookingInformation/v1/GetUserData",
      data: userdata,
      onNotify: this.GETUSERBOOKINGINFO,
    } as apiRequest<any>);
  }

  postgeneralenqiry(data) {
    this.post({
      url: "Common/GeneralEnquiry/v1/GeneralEnquiry",
      data: data,
      onNotify: this.GENERALEMAILSUCCESS,
      operationKey: "generalEnq_key",
      handleErrorThroughSubject: true,
    } as apiRequest<boolean>);
  }

  getSocialNetworking() {
    this.get<any>({
      url: "Common/YTBSocialNetWorking/v1/retrieveSocialNetworkingInfo",
      onNotify: this.SocialNetworkSuccess,
    } as apiRequest<any>);
  }

  travellerpricedropdown(res, label, value, currency, price) {
    var responseArray = [
      { label: "Select", value: "", currencyvalue: "", pricevalue: "" },
    ];
    for (let response of res) {
      responseArray.push({
        label: response[label],
        value: response[value],
        currencyvalue: response[currency],
        pricevalue: response[price],
      });
    }
    return responseArray;
  }

  /**
   *
   * @param userId logged in UserId
   * This function is used to fetch the billing address and shipping address to fill it in
   * payment page.
   */
  getAddressDetailsForUserId(userId) {
    this.post({
      url: "Common/UserAddress/v1/GetUserAddressByUserId",
      data: { userId: userId },
      onNotify: this.ADDRESSDETAILSFORUSERSUCESS,
    } as apiRequest<boolean>);
  }

  /**
   *
   * @param userId logged in userId
   * This function is used to fetch the emergency details for specific user to fill it in Details page
   */
  getEmergencyDetailsForUserId(userId) {
    this.post({
      url: "Common/EmergencyContact/v1/GetByUserid",
      data: { userId: userId },
      onNotify: this.EMERGENCYDETAILSFORUSERSUCESS,
    } as apiRequest<boolean>);
  }

  /**
   *
   * @param module module Name
   * This function is used to get all suppliers belongs to that module
   */
  getSuppliersForModule(module) {
    // let moduleObj;
    // moduleObj.moduleid = module;

    return this.post({
      url: "Common/Common/v1/supplierInfoByModule",
      data: { moduleid: module },
      onNotify: this.SUPPLIERINFOSUCCESS,
    });
  }

  /**
   *
   * @param requestObj query prams json object
   * this function is used to insert our query params object into database
   * It will takes request object value in string format
   */
  insertQueryParamsInfo(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.QUERYPARAMSINSERTSUCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  insertHotelQueryParamsInfo(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.QUERYPARAMSHOTELINSERTSUCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  /**
   *
   * @param address1
   * @param address2
   * @param address3
   * @param address4
   * @param address5
   * This function is used to concatenate all addresses into single address
   * it will remove nulls and empty strings in address
   */
  setCarLocation(
    address1 = "",
    address2 = "",
    address3 = "",
    address4 = "",
    address5 = ""
  ) {
    let add1, add2, add3, add4, add5;
    if (address1) {
      add1 = address1;
    } else {
      add1 = "";
    }
    if (address2) {
      if (add1) {
        add2 = add1 + "," + address2;
      } else {
        add2 = address2;
      }
    } else {
      if (add1) {
        add2 = add1;
      } else {
        add2 = "";
      }
    }
    if (address3) {
      if (add2) {
        add3 = add2 + "," + address3;
      } else {
        add3 = address3;
      }
    } else {
      if (add2) {
        add3 = add2;
      } else {
        add3 = "";
      }
    }

    if (address4) {
      if (add3) {
        add4 = add3 + "," + address4;
      } else {
        add4 = address4;
      }
    } else {
      if (add3) {
        add4 = add3;
      } else {
        add4 = "";
      }
    }

    if (address5) {
      if (add4) {
        add5 = add4 + "," + address5;
      } else {
        add5 = address5;
      }
    } else {
      if (add4) {
        add5 = add4;
      } else {
        add5 = "";
      }
    }

    return add5;
  }

  /**
   *
   * @param requestId request id which is coming while insert our query params into database
   * It will return all query params which we stored in database while navigation
   * It will return response in the form of string. So we need to do parse while we got response
   */
  getQueryParamsInfo(requestId) {
    return this.post({
      url: "Common/Request/v1/GetQueryParams",
      data: { requestId: requestId },
      onNotify: this.QUERYPARAMSGETSUCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  /**
   *
   * @param requestId request id which is coming while insert our query params into database
   * It will return all query params which we stored in database while navigation
   * It will return response in the form of string. So we need to do parse while we got response
   */
  getUserSignupQueryParamsInfo(requestId) {
    return this.post({
      url: "Common/Request/v1/GetQueryParams",
      data: { requestId: requestId },
      onNotify: this.USERSIGNUPQUERYPARAMSGETSUCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  getAgentSignupQueryParamsInfo(requestId) {
    return this.post({
      url: "Common/Request/v1/GetQueryParams",
      data: { requestId: requestId },
      onNotify: this.AGENTSIGNUPQUERYPARAMSGETSUCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  getFlightQueryParamsInfo(requestId) {
    return this.post({
      url: "Common/Request/v1/GetQueryParams",
      data: { requestId: requestId },
      onNotify: this.FLIGHTQUERYPARAMSGETSUCESS$,
      operationKey: "request_issue",
      handleErrorThroughSubject: true,
    });
  }

  /**
   *
   * @param requestObj
   * This function is used to insert is there any multiple set calls in same component.
   *
   */
  additionalQueryParamsInsertion(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.ADDITIONALQUERYPARAMSINSERTSUCESS$,
    });
  }

  /**
   *
   * @param requestObj
   * This function is used to insert is there any multiple set calls in same component.
   *
   */
  additionalDetailsQueryParamsInsertion(requestObj) {
    return this.post({
      url: "Common/Request/v1/InsertQueryParams",
      data: requestObj,
      onNotify: this.ADDITIONALDETAILSQUERYPARAMSINSERTSUCESS$,
    });
  }
  prepareLuggageDropdown(resp) {
    var responseArray = [{ label: "", value: null }];
    for (let res of resp) {
      responseArray.push({
        label: res.type + ": " + res.fare + " " + res.currency,
        value: res,
      });
    }
    return responseArray;
  }

  preparePassengersList(response) {
    var responseArray = [];
    let i = 0;
    for (let res of response) {
      responseArray.push({
        label: res.travellerName,
        value: i,
      });
      i++;
    }

    return responseArray;
  }

  prepareExtrasDropdown(resp) {
    var responseArray = [{ label: "", value: null }];
    for (let res of resp) {
      responseArray.push({
        label: res.type + ": " + " " + res.fare + " " + res.currency,
        value: res,
      });
    }
    return responseArray;
  }

  prepareFlightSegDropdown(resp) {
    var responseArray = [];
    for (let res of resp) {
      responseArray.push({
        label: res.flightNumber + " " + res.fromLocation + "-" + res.toLocation,
        value: res,
      });
    }
    return responseArray;
  }

  public findInvalidControlsRecursive(
    formToInvestigate: UntypedFormGroup | UntypedFormArray
  ): string[] {
    var invalidControls: string[] = [];
    let recursiveFunc = (form: UntypedFormGroup | UntypedFormArray) => {
      Object.keys(form.controls).forEach((field) => {
        const control = form.get(field);
        if (control.invalid) invalidControls.push(field);
        if (control instanceof UntypedFormGroup) {
          recursiveFunc(control);
        } else if (control instanceof UntypedFormArray) {
          recursiveFunc(control);
        }
      });
    };
    recursiveFunc(formToInvestigate);
    return invalidControls;
  }

  shedulechange(bookingPNR) {
    return this.post({
      url: "Common/FlightScheduler/v1/GetFlightSchedulePNRDetails",
      data: bookingPNR,
      onNotify: this.FlightScheduleChange$,
    });
  }

  preparePaidAncillariesDropdown(resp) {
    // var responseArray = [{ label: '-- Select Item --', value: null }];
    var responseArray = [];
    var bagArray = [];
    var otherAncillaryArray = [];
    var mealArray = [];
    var index = 0;
    for (let res of resp) {
      switch (res.ancillaryType) {
        case "BG":
          bagArray.push({ label: res.ancillaryServiceName, value: index });

          break;
        case "ML":
          mealArray.push({ label: res.ancillaryServiceName, value: index });
          break;

        case "OD":
          otherAncillaryArray.push({
            label: res.ancillaryServiceName,
            value: index,
          });
      }

      index++;
    }

    if (bagArray.length > 0) {
      responseArray.push({ label: "Paid Baggage", items: bagArray });
    }
    if (mealArray.length > 0) {
      responseArray.push({ label: "Paid Meals", items: mealArray });
    }
    if (otherAncillaryArray.length > 0) {
      responseArray.push({
        label: "Paid Other Items",
        items: otherAncillaryArray,
      });
    }
    return responseArray;
  }

  prepareOtherAncillariesDropdown(resp) {
    var responseArray = [{ label: "-- Select Item --", value: null }];
    var index = 0;
    for (let res of resp) {
      responseArray.push({
        label: res.ancillaryServiceName,
        value: index,
      });
      index++;
    }
    return responseArray;
  }

  getBookingclass() {
    this.get<any>({
      url: "Common/BookingClass/v1/GetAllBookingClass",
      onNotify: this.BOOKINGCLASSSUCCESS,
    } as apiRequest<any>);
  }

  getBaggageDetails(baggageobj) {
    this.post<any>({
      url: "Common/FlightBaggageDetails/V1/GetFlightBaggageDetails",
      data: baggageobj,
      onNotify: this.BAGGAGESUCCESS,
    } as apiRequest<any>);
  }

  prepareBookingClassDropdown(resp: BookingClass[]) {
    var responseArray = [{ label: "Select Booking Class", value: null }];
    for (let res of resp) {
      responseArray.push({ label: res.bookingClassName, value: res });
    }
    return responseArray;
  }

  getPopularDestinations(module: string[]) {
    this.post<any>({
      url: "Common/YTBTopDestinations",
      data: module,
      onNotify: this.destinationSuccess,
    } as apiRequest<any>);
  }

  logError(errorObj) {
    this.post<any>({
      url: "Common/writeUILogs",
      data: errorObj,
      onNotify: this.errorSuccess,
    } as apiRequest<any>);
  }

  paypalPaymentProcess(Obj) {
    this.post<any>({
      url: "Payments/PayPal/PaymentProcess",
      data: Obj,
      onNotify: this.paymentProcess,
    } as apiRequest<any>);
  }

  YTBTopDestinations(Obj) {
    this.post<any>({
      url: "Common/YTBTopDestinations",
      data: Obj,
      onNotify: this.TopDestinations,
    } as apiRequest<any>);
  }

  couponValidation(Obj) {
    this.post<any>({
      url: "Common/YTBCoupon/v1/YTBCouponValidation",
      data: Obj,
      onNotify: this.couponValidate$,
    } as apiRequest<any>);
  }

  couponDetaildById(Obj) {
    this.post<any>({
      url: "Common/YTBCoupon/v1/GetCouponId",
      data: Obj,
      onNotify: this.couponGetYTBCouponDetails$,
    } as apiRequest<any>);
  }

  YTBDynamicImages(Obj) {
    this.post<any>({
      url: "Common/YTBTopDestinations/v1/YTBDynamicImages",
      data: Obj,
      onNotify: this.ytbDynamicImages,
    } as apiRequest<any>);
  }

  getAllCoupons(moduleCode: string, coupon_code: string) {
    this.post<any>({
      url: "Common/YTBCoupon/v1/GetAllCoupons",
      data: {
        module: moduleCode,
        timeZone: this.getBrowserTimeZone(),
        couponcode: coupon_code,
      },
      onNotify: this.coupons,
      handleErrorThroughSubject: true,
      operationKey: "coupon_ex",
    } as apiRequest<any>);
  }

  YTBDeals(Obj) {
    this.post<any>({
      url: "Common/YTBTopDestinations/v1/YTBDynamicImages",
      data: Obj,
      onNotify: this.deals$,
    } as apiRequest<any>);
  }

  AssignCouponToUser(Obj) {
    this.post<any>({
      url: "Common/YTBCoupon/v1/AssignYTBCouponToUser",
      data: Obj,
      onNotify: this.assignCoupons,
    } as apiRequest<any>);
  }

  getKey() {
    // this.getFile<any>({
    //   url: "Common/getKey",
    //   onNotify: this.keySuccess$
    // } as apiRequest<any>);

    this.keySuccess$.next({ data: environment.publicKey });
  }

  fetchIPAddress(url: string) {
    this.get<{ ip: string }>({
      url: url,
      onNotify: this.fetchIPAdressSuccess$,
    });
  }

  getCookie(name: string) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  setCookie(name: string, value: string, expires?: Date | string) {
    document.cookie =
      name + "=" + (value || "") + ";expires=" + expires + ";path=/";
  }

  deleteCookie(name) {
    document.cookie =
      name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  getFlightAirlineSegmentStatus() {
    return this.get({
      url: "Common/AirlinesFlightSegment/V1/GetAllAirlinesFlightSegments",
      onNotify: this.flightSegmentStatusSuccess$,
    });
  }

  public async getUrlAsync() {
    return environment.digicelCertificateUrl;
  }

  openDigicel() {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      var url = environment.digicelCertificateUrl;
      // var url = new URL(environment.digicelCertificateUrl);

      try {
        // var playerUrl = url;
        // var popupPlayer = window.open('', 'popupPlayer', 'width=550,height=550');
        // if (popupPlayer.location.href == 'about:blank') {
        //   popupPlayer.location.replace(playerUrl);
        // }
        // popupPlayer.history.pushState('Pattern', 'DigiCel ', url);
        // popupPlayer.history.replaceState('Pattern', 'DigiCel ', url);
        // popupPlayer.location.reload();
        // popupPlayer.location.replace(playerUrl);
        // var w = 500;
        // var h = 500;
        // var left = (screen.width / 2) - (w / 2);
        // var top = (screen.height / 2) - (h / 2);
        // var targetWin = window.open(url, "_blank", 'toolbar=no, location=no,directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
        // targetWin.document.documentElement.innerHTML = "<a href=" + url + "> </a>"
        // var windowStr = targetWin.document.documentElement.innerHTML;
        // console.log(windowStr);
        // var doc = document;
        // jQuery('.openDigicelInNewLinkWithImport').click(function (e) {
        //   console.log(e)
        //   e.preventDefault();
        //   var newwindow = window.open(jQuery(this).attr('href'), 'importwindow', 'width=500, height=200, top=100, left=200, toolbar=1');
        //   newwindow.onload = function () {
        //     console.log("Inside of onload event ")
        //     newwindow.onbeforeunload = function () {
        //       console.log("Inside of onload event ")
        //       doc.location.reload(); //will refresh page after popup close
        //     }
        //   }
        // });
      } catch (error) {
        console.log(error);
      }

      // var win = window.open(url, '_blank');
      // alert(win.location.protocol + "//" + win.location.host + "/" + win.location.pathname)

      // // win.location.href = url;
      // // alert(win.location.href);
      // var URL = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname;
      // alert(URL);

      // win.location.protocol = "http:";
      // win.location.host = "seal.digicert.com";
      // win.location.pathname = "/seals/popup/";

      // alert(win.location)

      // alert(win.location.href)
      // win.location.search = "?tag=CDUv_WQ4";

      // win.opener = null;
      // win.focus();
      // win.location = url;

      // win.setTimeout(() => {
      //   alert("Inside of time out ")
      // }, 2000);
    }

    // var targetWin = window.open('', '_blank', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no');
    // targetWin.addEventListener('load', function () {
    //   // Continue doing stuff here.
    //   console.log("Inside of Load Event Listener")

    //   targetWin.location.replace('https://www.google.com/');

    // });

    // targetWin.setTimeout(() => {
    //   targetWin.location.href = url;
    //   console.log("Inside of time out ")
    // }, 300);

    // var str = "Testing!";
    // var result = str.link(url);
    // console.log(result);
    // const link = result;

    // const link = document.createElement('a');
    // link.target = '_blank';
    // link.href = environment.digicelCertificateUrl;
    // link.setAttribute('visibility', 'hidden');
    // link.click();
    // link.replaceWith('href', environment.digicelCertificateUrl);
    // link.querySelector('a').click();

    // var w = window.open();
    // const w = window.open('', '_blank');
    // w.location.href = environment.digicelCertificateUrl;
    // w.setInterval(() => {
    //   alert("Inside of Time out ")
    //   w.location.replace(environment.digicelCertificateUrl);

    //   w.location.reload();
    // }, 1000);

    // var popup = window.open(environment.digicelCertificateUrl, "snapDown");
    // popup.onload = function () {
    //   alert("Inside of onload ")
    //   popup.location.reload();
    // };

    // popup.onloadstart = function (e) {
    //   alert(e);
    // }

    // var winGoogle = window.open("http://www.google.com", "google", "status,heigh​t=600,width=800");
    // winGoogle.onload = function () {
    //   alert("All done!");
    // }

    // const w = window.open('', '_blank');
    // w.document.write("<html><head></head><body>Please wait while we redirect you</body></html>");
    // w.document.close();
    // const url = await this.getUrlAsync();
    // w.location.href = url;
    // console.log(w.location);
    // w.name = "Digicel Certificate";
    // if (w.opener) {
    //   console.log("Inside of opened")
    // }
    // w.setTimeout(() => {
    //   console.log(w.location.href);
    //   w.location.reload();
    // }, 2000);

    // var w = window.open();
    // w.location.href = environment.digicelCertificateUrl;
    // w.setTimeout(() => {
    //   w.location.replace(environment.digicelCertificateUrl);

    //   w.location.reload();
    // },3000);

    // var popup=window.open(environment.digicelCertificateUrl, 'Digicel', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    // popup.focus();

    // alert(popup.location.href)

    // let newWin = window.open("about:blank", "hello", "width=500,height=500");

    // newWin.location.href=environment.digicelCertificateUrl;

    // newWin.location.href = environment.digicelCertificateUrl;
    // newWin.location.assign(environment.digicelCertificateUrl);
    // console.log(newWin.opener);
    // console.log(newWin.closed);
    // newWin.setTimeout(() => {
    // newWin.location.replace(environment.digicelCertificateUrl);
    // newWin.setTimeout(() => {
    //   newWin.location.reload();
    //   newWin.location.reload();
    // }, 5000);
    // }, 3000);

    // var popup = window.open("about:blank", "_blank");
    // popup.location.href = null;
    // popup.location.href = environment.digicelCertificateUrl;
    // popup.focus();

    // popup.onload = function () {
    //   if (!popup.location.hash) {
    //     popup.location = popup.location + '#loaded';
    //     popup.location.reload();
    //   }
    // }

    // popup.location.reload();

    // var childWindow =

    // const tab = window.open('about:blank', 'width=850,height=1600, scrollbars=1');

    // tab.location = environment.digicelCertificateUrl;

    // tab.focus();
    // init urls
    // open window with url of current page, you will be automatically moved
    // by browser to a new opened tab. It will look like your page is reloaded
    // and you will stay on same page but with new page opened
    // window.open(newUrl, '_blank', 'width=850,height=1000, scrollbars=1');
    // window.open(environment.digicelCertificateUrl, '_blank', 'width=850,height=1000, scrollbars=1');

    // var childWindow = window.open(environment.digicelCertificateUrl);
    // childWindow.location.reload();
    // childWindow.focus();

    // const link = document.createElement('a');
    // link.target = '_blank';
    // link.href = environment.digicelCertificateUrl;
    // link.setAttribute('visibility', 'hidden');
    // link.click();

    // on your current tab will be opened new url
    // location.href = newUrl;

    // Now delete it
    // evLink.parentNode.removeChild(evLink);

    // tab.location = environment.digicelCertificateUrl : Location;
    // tab.focus();

    // window.open(environment.digicelCertificateUrl, '_blank', 'width=850,height=1600, scrollbars=1').focus();

    // var childWindow1 = window.open('https://seal.digicert.com/seals/popup/?tag=CDUv_WQ4&url=www.digicert.com&lang=en&cbr=1630421766210').location.reload();

    // window.location.reload();
    // setTimeout(() => {
    // childWindow.onfocus=this.windowClose;

    // childWindow.location.reload();

    // },1000);
  }

  windowClose() {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      window.location.reload();
    }
  }

  getToken() {
    this.get<string>({
      url: "user/token",
      onNotify: this.token$,
    });
  }

  getAuthStr() {
    // let date = new Date(1970,1,1,0,0,0,0);
    //         let d = new Date();
    //         let utc = new Date(Date.UTC(
    //         date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate(),
    //         date.getUTCHours(),date.getUTCMinutes(), date.getUTCSeconds()));
    //         let value = new Date(Date.UTC(
    //             d.getUTCFullYear(),d.getUTCMonth(),d.getUTCDate(),
    //             d.getUTCHours(),d.getUTCMinutes(), d.getUTCSeconds()));
    let num = Date.now();
    let hash = SHA256(authObj["app-Id"] + authObj.secretKey + num).toString(
      enc.Hex
    );
    // console.log(num)
    return `${authObj["app-Id"]}:B2C-${num}:${hash}`;
  }

  getEnquireHistory(requestObj) {
    return this.post({
      url: "Common/GeneralEnquiryDetails/v1/GetAllGeneralEnquiryHstory",
      data: requestObj,
      onNotify: this.enqHistory$,
    });
  }

  isObjectEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  /**
   * @params cardTypeObject,cardListObjectArray,cardNumber,regExString
   * @author : Ryan
   * @description : This method is used to format payment card Numbers (credit cards)
   */
  formatPaymentCards(
    cardTypeObject: any[],
    cardListObjectArray: any[],
    cardNumber: any
  ) {
    let gaps = cardTypeObject[0].gaps[0];
    let regExString = ".{1," + gaps + "}";
    let cardType: any = cardListObjectArray.filter(
      (x) => x.type == cardTypeObject[0].niceType
    );
    let creditCardNo = cardNumber.match(new RegExp(regExString, "g")).join("-");
    return {
      cardNo: creditCardNo,
      cardLogo: cardType && cardType.length > 0 ? cardType[0].images : "",
      cardCompany:
        cardTypeObject && cardTypeObject.length > 0
          ? cardTypeObject[0].niceType
          : "",
    };
  }

  getGeoLocaton() {
    this.get<any>({
      url: "api/geolocation/",
      onNotify: this.GeoLocationFromServer,
    } as apiRequest<any>);
  }

  getError(control: AbstractControl | null, name: string): string | null {
    if (
      control &&
      control.touched &&
      control.errors &&
      control.errors["required"]
    ) {
      return `${name} is required.`;
    } else if (control && control.errors) {
      if (control.errors["minlength"]) {
        return `Please enter minimum 3 characters`;
      } else if (control.errors["pattern"]) {
        return `${name} must be valid [a-b and A-B] only`;
      } else if (control.errors["space"]) {
        return `Only one space allows between the letters`;
      }
    }
    return null;
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  scrollToFirstInvalidControl(form: FormGroup, elRef: ElementRef): void {
    // Find the first invalid control
    for (const key of Object.keys(form.controls)) {
      const control = form.controls[key];
      if (control.invalid) {
        const invalidControl = elRef.nativeElement.querySelector(
          `[formControlName="${key}"]`
        );

        if (invalidControl) {
          invalidControl.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          invalidControl.focus();
        }

        break; // Stop after the first invalid control
      }
    }
  }
}
